import { render, staticRenderFns } from "./ComponentBook.vue?vue&type=template&id=07d1c8ed"
import script from "./ComponentBook.vue?vue&type=script&lang=js"
export * from "./ComponentBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports